import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "../lib/scroll";

const links = [
  { label: "Woningen", href: "#woningen", testid: "nav-link-woningen" },
  { label: "Over ons", href: "#over-ons", testid: "nav-link-over-ons" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "bg-background/85 backdrop-blur-md border-border"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.2 })}
          className="font-display font-black text-xl tracking-tighter"
        >
          RENT&nbsp;GURU<span className="align-super text-[10px]">®</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={l.testid}
              onClick={() => scrollToId(l.href)}
              className="text-sm font-medium tracking-wide text-foreground/70 hover:text-foreground transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta-bekijk-woningen"
          onClick={() => scrollToId("#woningen")}
          className="bg-foreground text-background text-sm font-medium px-5 py-2.5 hover:bg-foreground/85 transition-colors duration-200"
        >
          Bekijk woningen
        </button>
      </div>
    </motion.header>
  );
};
